{
  "name": "@unkey/api",
  "version": "0.19.4",
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "license": "MIT",
  "private": false,
  "publishConfig": {
    "access": "public"
  },
  "keywords": [
    "unkey",
    "client",
    "api"
  ],
  "bugs": {
    "url": "https://github.com/unkeyed/unkey/issues"
  },
  "homepage": "https://github.com/unkeyed/unkey#readme",
  "files": [
    "./dist/**"
  ],
  "author": "Andreas Thomas <andreas@chronark.com>",
  "scripts": {
    "generate": "openapi-typescript https://api.unkey.dev/openapi.json -o ./src/openapi.d.ts",
    "build": "pnpm generate && tsup"
  },
  "devDependencies": {
    "@types/node": "^20.11.24",
    "@unkey/tsconfig": "workspace:^",
    "openapi-typescript": "^6.7.4",
    "tsup": "^8.0.2",
    "typescript": "^5.3.3"
  },
  "dependencies": {
    "@unkey/rbac": "workspace:^"
  }
}
